export default "__VITE_ASSET__D$BiEnbD__"